/* eslint-disable no-await-in-loop  */
import { evaluateConditionGroup } from './evaluate-condition';
import { executeAction } from './execute-action';
import type {
  ActionResult,
  FormData,
  LogicItem,
  StateChange,
} from '../logic-builder-types';

function shouldExecuteLogicItem(
  logicItem: LogicItem,
  changedFields?: Array<string>,
): boolean {
  if (!changedFields) {
    return true;
  }

  return logicItem.conditionGroups.some(conditionGroups =>
    conditionGroups.conditions.some(condition =>
      // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2345
      changedFields.includes(condition.fieldId),
    ),
  );
}

async function logicEngine(
  logic: Array<LogicItem>,
  formData: FormData,
  changedFields?: Array<string>,
): Promise<{
  [key: string]: ActionResult;
}> {
  const stateChanges: StateChange = {};

  for (const logicItem of logic) {
    if (shouldExecuteLogicItem(logicItem, changedFields)) {
      let allConditionGroupsTrue = true;

      for (const conditionGroup of logicItem.conditionGroups) {
        const conditionResult = await evaluateConditionGroup(
          conditionGroup,
          formData,
        );

        if (!conditionResult) {
          allConditionGroupsTrue = false;
          break;
        }
      }

      const actionSet = allConditionGroupsTrue
        ? logicItem.actions
        : logicItem.elseActions;

      for (const actionType of Object.keys(actionSet)) {
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS7015
        const actionData = actionSet[actionType];
        // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2345
        const results = await executeAction(actionType, actionData);

        for (const result of results) {
          stateChanges[result.fieldId] = {
            ...stateChanges[result.fieldId],
            ...result.newState,
          };
        }
      }
    }
  }

  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322
  return stateChanges;
}

export { logicEngine };
